import { useContext } from 'react';
import { EditProtocolContext } from './EditProtocolContextProvider';

function useEditProtocolContext() {
    return useContext(EditProtocolContext);
}

export default useEditProtocolContext;
